import { authApi } from "../../../../helper/api";
import { mConstants } from "../../../../helper/constants";
import { mUtils } from "../../../../helper/utils";
import { Group, Route, User, UserUI } from "../entity/user.model";

const userUrl = `/ma/admin/realms/${mConstants.REALM}`;
const routeUrl = `/mo/users/`;

async function getUsers(
  username?: string,
  routeId?: string
): Promise<UserUI[]> {
  let params;

  if (username) {
    params = { username };
  }

  let users: UserUI[] = await authApi.get(`${userUrl}/users`, { params });

  if (routeId) {
    users = users.filter((user) => {
      return (
        (user.attributes?.routeId &&
          user.attributes?.routeId.includes(routeId)) ||
        (user.attributes?.routes && user.attributes?.routes.includes(routeId))
      );
    });
  }

  return users.map((user) => {
    user.label = mUtils.formatListItemUser(user);
    user.value = user.username;
    return user;
  });
}

async function getUser(uuid: string): Promise<UserUI> {
  const user: User = await authApi.get(`${userUrl}/users/${uuid}`);
  const group = await getUserGroup(uuid);
  return { ...user, group, label: mUtils.formatListItemUser(user) };
}

async function getGroups(): Promise<Group[]> {
  const groups: Group[] = await authApi.get(
    `${userUrl}/groups?briefRepresentation=false`
  );
  return groups.map((x) => {
    return { ...x, value: x.id, label: x.name };
  });
}

async function getUserGroup(userId: string): Promise<Group | undefined> {
  const groups: Group[] = await authApi.get(
    `${userUrl}/users/${userId}/groups?briefRepresentation=false`
  );

  if (groups.length > 0) {
    let group = groups[0];

    return { ...group, value: group.id, label: group.name };
  }

  return undefined;
}

async function updateUser(user: User): Promise<User> {
  return await authApi.put(`${userUrl}/users/${user.id}`, user);
}

async function addUser(user: User): Promise<User> {
  return authApi.post(`${userUrl}/users`, user);
}

function addUserGroup(userId: string, group: Group) {
  return authApi.put(`${userUrl}/users/${userId}/groups/${group.id}`);
}

function deleteUserGroup(userId: string, group: Group) {
  return authApi.delete(`${userUrl}/users/${userId}/groups/${group.id}`);
}

function deleteUser(userId: string) {
  return authApi.delete(`${userUrl}/users/${userId}`);
}

function getUserRoute(username: string): Promise<Route> {
  return authApi.get(`${routeUrl}route/${username}`);
}

async function updatingUserGroup(
  userId: string,
  addingGroup: Group,
  existingGroup: Group | undefined
) {
  await addUserGroup(userId, addingGroup);

  if (existingGroup) {
    await deleteUserGroup(userId, existingGroup);
  }
}

export const userService = {
  getUsers,
  getUser,
  getGroups,
  updateUser,
  getUserGroup,
  updatingUserGroup,
  addUser,
  deleteUser,
  getUserRoute,
};
